/**
 * @typedef {'BASIC' | 'ESSENTIAL' | 'INTERMEDIATE' | 'ASSOCIATE' | 'ADVANCE' | 'PROFESSIONAL'} Level
 * @typedef {{ color: 'blue' | 'teal' | 'coral', text: string }} BadgeInfo
 */

/** @type {Record<Level, BadgeInfo>} */
export const LEVEL_BADGE = {
  BASIC: { color: 'blue', text: 'Basic' },
  ESSENTIAL: { color: 'blue', text: 'Essential' },
  INTERMEDIATE: { color: 'teal', text: 'Intermediate' },
  ASSOCIATE: { color: 'teal', text: 'Associate' },
  ADVANCE: { color: 'coral', text: 'Advance' },
  PROFESSIONAL: { color: 'coral', text: 'Professional' },
}

/**
 * @param {string} level
 * @returns {BadgeInfo['color']}
 */
export const getBadgeColor = (level) => {
  return LEVEL_BADGE[level]?.color || 'blue'
}

/**
 * @param {string} level
 * @returns {string}
 */
export const getBadgeText = (level) => {
  return LEVEL_BADGE[level]?.text || 'Basic'
}
